export interface GameContent {
  title: string;
  description?: string;
  path: string;
  image?: string;
}

export const GAME_LIST: Record<string, GameContent> = {
  rxkitty: {
    title: "RXKitty",
    path: "https://d1mw270rtra4go.cloudfront.net/rxkitty2d/RxKitty_2D.html",
    // description: "An Amazing 2D Platformer Game",
    image: "https://d1mw270rtra4go.cloudfront.net/rxkitty2d/artwork.png",
  },
  priest: {
    title: "Priest",
    path: "https://d1mw270rtra4go.cloudfront.net/priest/index.html",
    // description: "An Amazing 3D Adventure Game",
    image: "https://d1mw270rtra4go.cloudfront.net/priest/artwork.png",
  },
  "path-of-reflections": {
    title: "Priest",
    path: "https://d1mw270rtra4go.cloudfront.net/path-of-reflections/index.html",
    // description: "An Amazing 3D Adventure Game",
    image:
      "https://d1mw270rtra4go.cloudfront.net/path-of-reflections/artwork.png",
  },
};
